module.exports = __webpack_public_path__ + "static/info11.f73369ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mini_portal/Community/info11.png
// module id = 821
// module chunks = 68530290604204